import React from 'react'
import reportStyles from './PDFReportStyles';    
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'

const NutritionalPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/NutritionalHeader.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Nutritional Strength - Section 1</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell40NBLeft}>
                    <Text style={reportStyles.PageSubTitle}>Overall Assessment</Text>
                </View>
                <View style={reportStyles.cell60NBLeft}>
                    <Image src={process.env.PUBLIC_URL + '/images/Red75Ind.png'} style={reportStyles.imageIndCell}/>                                                 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50BB}>
                </View>
                <View style={reportStyles.cell50BB}>
                </View>
            </View>                                
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Primary Nutrient Balance</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/NutritionalBalance.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/Red75Ind.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Protein Sufficiency</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Protein.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/GreenMidInd.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Vitamins & Minerals Inputs</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Vitamins.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeLowInd.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Harmful Foods & Habits</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/HarmfulFood.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/GreenLowInd.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40}>
                    <Text style={reportStyles.PageText}>Need For Consultation</Text>
                </View>
                <View style={reportStyles.cell20}>
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeCheck.png'} style={reportStyles.image33Cell}/> 
                </View>
                <View style={reportStyles.cell40}>
                    <Text style={reportStyles.PageText}>Recommended*</Text>
                </View>
            </View>
        </View>                                   
       </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Indicates if it is apparent that a consultation with a Child Nutritionist within a short period of time
            could be useful in improving the physical wellbeing of the child. This is calculated based on the
            answers received in the scan and peer comparisons.</Text>
    </View>                            
  </Page>                      

  )          
}
  
export default NutritionalPage